import React from 'react';

const AddCircleBold = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    id="Add-Circle-Bold-Alternate--Streamline-Ultimate"
    height="24"
    width="24"
  >
    <desc>
      Add Circle Bold Alternate Streamline Icon: https://streamlinehq.com
    </desc>
    <g>
      <path
        d="M12 0a12 12 0 1 0 12 12A12 12 0 0 0 12 0Zm0 21a9 9 0 1 1 9 -9 9 9 0 0 1 -9 9Z"
        fill="#000000"
        strokeWidth="1"
      />
      <path
        d="M17.25 10.57h-3.57a0.25 0.25 0 0 1 -0.25 -0.25V6.75a1 1 0 0 0 -0.95 -1h-1a1 1 0 0 0 -0.95 1v3.57a0.25 0.25 0 0 1 -0.25 0.25H6.75a1 1 0 0 0 -1 0.95v1a1 1 0 0 0 1 0.95h3.57a0.25 0.25 0 0 1 0.25 0.25v3.57a1 1 0 0 0 0.95 0.95h1a1 1 0 0 0 0.95 -0.95v-3.61a0.25 0.25 0 0 1 0.25 -0.25h3.57a1 1 0 0 0 0.95 -0.95v-1a1 1 0 0 0 -0.99 -0.91Z"
        fill="#000000"
        strokeWidth="1"
      />
    </g>
  </svg>
);

export default AddCircleBold;
